<template>
  <div>
    <p>
      The space object is a simplified object for a potentially maneuvering
      spacecraft. The characteristics of the space object are filled by a user.
      All parameters are necessary to be able to restitute maneuvers.
    </p>
    <p>
      The geometry of the space object is here approximated by a spherical
      geometry since the exact shape of the space object might not be known.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipSpaceObject'
}
</script>
